module.exports = __webpack_public_path__ + "media/images/Pineapple_outline_icon-562e0cc2.png";